import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'dialog-result-example-dialog',
    template: require('./changelog.component.html'),
    styles: [require('./changelog.component.css')],
})
export class PageLayoutViewChangeLogComponent {    
    changeLogData;

    constructor(
        public dialogRef: MdDialogRef<PageLayoutViewChangeLogComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.changeLogData = this.data.ChangeLog;
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/extra-pages/changelog/changelog.component.ts